module.exports = __webpack_public_path__ + "static/media/alodok.7c5643d2.webp";